import React from "react";
import { useParams } from "react-router";
import ActivityView from "../../../common/activity/ActivityView";
import { RefActivity } from "../../../api/hooks";

const TransferVoucherDetailActivity = () => {
    const { transferVoucherId } = useParams<any>();
    return (
        <div>
            {transferVoucherId && (
                <ActivityView
                    className="mt-3 border"
                    activityRef={RefActivity?.TransferVoucher}
                    activityRefId={transferVoucherId ?? ""}
                />
            )}
        </div>
    );
};

export default TransferVoucherDetailActivity;
